import { Typography } from 'antd';
import styles from './time-period-message.module.scss';
import type { ITimePeriodMessageProps } from './types';

export const TimePeriodMessage: React.FC<ITimePeriodMessageProps> = ({ timePeriod }) => {
  return (
    <>
      {timePeriod === 'soon' ? <Typography.Text className={styles.soon}>Soon</Typography.Text> : null}
      {timePeriod === 'between' ? <Typography.Text className={styles.warning}>Need action</Typography.Text> : null}
      {timePeriod === 'expired' ? <Typography.Text className={styles.expired}>Overdue</Typography.Text> : null}
    </>
  );
};
